import { redirectResellerBasedOnSetup } from '@/helpers/router';
import { getUser } from '@/helpers/auth';

const resellersRoutes = [
    {
        path: '/resellers',
        redirect: redirectResellerBasedOnSetup(),
        component: () => import('@/views/Resellers'),
        meta: { requiresAuth: true, checkUserRole: true },
        children: [
            {
                path: 'dashboard',
                name: 'Resellers Dashboard',
                component: () => import('@/views/Resellers/Clients'),
                beforeEnter: (to, from, next) => {
                    const user = getUser();

                    if (user.reseller.setup_completed === false || user.reseller.setup_completed === 0) {
                        next(false);
                    } else {
                        next();
                    }
                },
            },
            {
                path: 'profiles',
                name: 'Resellers Profiles',
                component: () => import('@/views/Resellers/Profiles'),
                beforeEnter: (to, from, next) => {
                    const user = getUser();

                    if (user.reseller.setup_completed === false || user.reseller.setup_completed === 0) {
                        next(false);
                    } else {
                        next();
                    }
                },
            },

            {
                path: 'profiles/add',
                name: 'Resellers Profiles Add',
                component: () => import('@/views/Resellers/Profiles/AddProfile'),
                beforeEnter: (to, from, next) => {
                    const user = getUser();

                    if (user.reseller.setup_completed === false || user.reseller.setup_completed === 0) {
                        next(false);
                    } else {
                        next();
                    }
                },

            },

            {
                path: 'profiles/edit/:id',
                name: 'Resellers Profiles Edit',
                component: () => import('@/views/Resellers/Profiles/EditProfile'),
                beforeEnter: (to, from, next) => {
                    const user = getUser();

                    if (user.reseller.setup_completed === false || user.reseller.setup_completed === 0) {
                        next(false);
                    } else {
                        next();
                    }
                },
            },

            {
                path: 'profiles/:id/combine',
                name: 'Resellers Profiles Combine',
                component: () => import('@/views/Resellers/Profiles/Combine/CombineProfile'),
                beforeEnter: (to, from, next) => {
                    const user = getUser();

                    if (user.reseller.setup_completed === false || user.reseller.setup_completed === 0) {
                        next(false);
                    } else {
                        next();
                    }
                },
            },

            {
                path: 'summary',
                name: 'Resellers Summary',
                component: () => import('@/views/Resellers/Summary'),
            },
            {
                path: 'clients/add',
                name: 'Resellers Clients Add',
                component: () => import('@/views/Resellers/Clients/AddClient'),
            },
        ],
    },
];

export default resellersRoutes;
